<template>
  <section>
    <b-button @click="requestSection(1)">section 1</b-button>
    <b-button @click="requestSection(2)">section 2</b-button>
    <b-button @click="requestSection(3)">section 3</b-button>
  </section>
</template>

<script>
export default {
  name: "ExampleButtons",
  methods: {
    requestSection(id) {
      this.$store.dispatch("set_popup", id);
    },
  },
};
</script>

<style scoped></style>
